export default __webpack_public_path__ + "static/qavant.devices-519a5c259990a12e81b8d910ddc81bfc.svg";